import styled from 'styled-components';

import Picture from 'components/picture';

export const StyledPicture = styled(Picture)`
  margin: 3rem auto auto auto;
  max-width: 16.25rem;
`;
